import React from 'react'
import PropTypes from 'prop-types'

import './Logo.scss'

const Logo = ({ image, customClassName, id }) => {
  return (
    <div
      id={id}
      className={`ou_static-logo ${customClassName}`}
      style={{ backgroundImage: `url(${image})` }}
    />
  )
}

Logo.propTypes = {
  image: PropTypes.string,
  customClassName: PropTypes.string,
  id: PropTypes.string
}

export default Logo



// WEBPACK FOOTER //
// ./src/templates/outSide/components/Logo.js